/**
 * @fileoverview gRPC-Web generated client stub for playbook
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: playbook/playbook.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var common_model_pb = require('../common/model_pb.js')

var chatcontext_chatcontext_pb = require('../chatcontext/chatcontext_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.playbook = require('./playbook_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.playbook.PlaybookServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.playbook.PlaybookServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.ObjectIdRequest,
 *   !proto.playbook.PlaybookResponse>}
 */
const methodDescriptor_PlaybookService_GetPlaybook = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookService/GetPlaybook',
  grpc.web.MethodType.UNARY,
  proto.playbook.ObjectIdRequest,
  proto.playbook.PlaybookResponse,
  /**
   * @param {!proto.playbook.ObjectIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.playbook.PlaybookResponse.deserializeBinary
);


/**
 * @param {!proto.playbook.ObjectIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.playbook.PlaybookResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.playbook.PlaybookResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookServiceClient.prototype.getPlaybook =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookService/GetPlaybook',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_GetPlaybook,
      callback);
};


/**
 * @param {!proto.playbook.ObjectIdRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.playbook.PlaybookResponse>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookServicePromiseClient.prototype.getPlaybook =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookService/GetPlaybook',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_GetPlaybook);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.UpdatePlaybookRequest,
 *   !proto.playbook.PlaybookResponse>}
 */
const methodDescriptor_PlaybookService_UpdatePlaybook = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookService/UpdatePlaybook',
  grpc.web.MethodType.UNARY,
  proto.playbook.UpdatePlaybookRequest,
  proto.playbook.PlaybookResponse,
  /**
   * @param {!proto.playbook.UpdatePlaybookRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.playbook.PlaybookResponse.deserializeBinary
);


/**
 * @param {!proto.playbook.UpdatePlaybookRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.playbook.PlaybookResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.playbook.PlaybookResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookServiceClient.prototype.updatePlaybook =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookService/UpdatePlaybook',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_UpdatePlaybook,
      callback);
};


/**
 * @param {!proto.playbook.UpdatePlaybookRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.playbook.PlaybookResponse>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookServicePromiseClient.prototype.updatePlaybook =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookService/UpdatePlaybook',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_UpdatePlaybook);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.ListPlaybooksRequest,
 *   !proto.playbook.PlaybooksResponse>}
 */
const methodDescriptor_PlaybookService_ListPlaybooks = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookService/ListPlaybooks',
  grpc.web.MethodType.UNARY,
  proto.playbook.ListPlaybooksRequest,
  proto.playbook.PlaybooksResponse,
  /**
   * @param {!proto.playbook.ListPlaybooksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.playbook.PlaybooksResponse.deserializeBinary
);


/**
 * @param {!proto.playbook.ListPlaybooksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.playbook.PlaybooksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.playbook.PlaybooksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookServiceClient.prototype.listPlaybooks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookService/ListPlaybooks',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_ListPlaybooks,
      callback);
};


/**
 * @param {!proto.playbook.ListPlaybooksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.playbook.PlaybooksResponse>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookServicePromiseClient.prototype.listPlaybooks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookService/ListPlaybooks',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_ListPlaybooks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.ObjectIdRequest,
 *   !proto.playbook.PlaybookRunResponse>}
 */
const methodDescriptor_PlaybookService_GetPlaybookRun = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookService/GetPlaybookRun',
  grpc.web.MethodType.UNARY,
  proto.playbook.ObjectIdRequest,
  proto.playbook.PlaybookRunResponse,
  /**
   * @param {!proto.playbook.ObjectIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.playbook.PlaybookRunResponse.deserializeBinary
);


/**
 * @param {!proto.playbook.ObjectIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.playbook.PlaybookRunResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.playbook.PlaybookRunResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookServiceClient.prototype.getPlaybookRun =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookService/GetPlaybookRun',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_GetPlaybookRun,
      callback);
};


/**
 * @param {!proto.playbook.ObjectIdRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.playbook.PlaybookRunResponse>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookServicePromiseClient.prototype.getPlaybookRun =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookService/GetPlaybookRun',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_GetPlaybookRun);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.ObjectIdRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_PlaybookService_DeletePlaybook = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookService/DeletePlaybook',
  grpc.web.MethodType.UNARY,
  proto.playbook.ObjectIdRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.playbook.ObjectIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.playbook.ObjectIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookServiceClient.prototype.deletePlaybook =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookService/DeletePlaybook',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_DeletePlaybook,
      callback);
};


/**
 * @param {!proto.playbook.ObjectIdRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookServicePromiseClient.prototype.deletePlaybook =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookService/DeletePlaybook',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_DeletePlaybook);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.ObjectIdRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_PlaybookService_DeletePlaybookRun = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookService/DeletePlaybookRun',
  grpc.web.MethodType.UNARY,
  proto.playbook.ObjectIdRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.playbook.ObjectIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.playbook.ObjectIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookServiceClient.prototype.deletePlaybookRun =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookService/DeletePlaybookRun',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_DeletePlaybookRun,
      callback);
};


/**
 * @param {!proto.playbook.ObjectIdRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookServicePromiseClient.prototype.deletePlaybookRun =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookService/DeletePlaybookRun',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_DeletePlaybookRun);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.FavoriteRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_PlaybookService_SetFavorite = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookService/SetFavorite',
  grpc.web.MethodType.UNARY,
  proto.playbook.FavoriteRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.playbook.FavoriteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.playbook.FavoriteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookServiceClient.prototype.setFavorite =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookService/SetFavorite',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_SetFavorite,
      callback);
};


/**
 * @param {!proto.playbook.FavoriteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookServicePromiseClient.prototype.setFavorite =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookService/SetFavorite',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_SetFavorite);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.RunPlaybookRequest,
 *   !proto.playbook.RunPlaybookResponse>}
 */
const methodDescriptor_PlaybookService_RunPlaybook = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookService/RunPlaybook',
  grpc.web.MethodType.UNARY,
  proto.playbook.RunPlaybookRequest,
  proto.playbook.RunPlaybookResponse,
  /**
   * @param {!proto.playbook.RunPlaybookRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.playbook.RunPlaybookResponse.deserializeBinary
);


/**
 * @param {!proto.playbook.RunPlaybookRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.playbook.RunPlaybookResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.playbook.RunPlaybookResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookServiceClient.prototype.runPlaybook =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookService/RunPlaybook',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_RunPlaybook,
      callback);
};


/**
 * @param {!proto.playbook.RunPlaybookRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.playbook.RunPlaybookResponse>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookServicePromiseClient.prototype.runPlaybook =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookService/RunPlaybook',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_RunPlaybook);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.CreatePlaybookRequest,
 *   !proto.playbook.PlaybookResponse>}
 */
const methodDescriptor_PlaybookService_CreatePlaybook = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookService/CreatePlaybook',
  grpc.web.MethodType.UNARY,
  proto.playbook.CreatePlaybookRequest,
  proto.playbook.PlaybookResponse,
  /**
   * @param {!proto.playbook.CreatePlaybookRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.playbook.PlaybookResponse.deserializeBinary
);


/**
 * @param {!proto.playbook.CreatePlaybookRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.playbook.PlaybookResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.playbook.PlaybookResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookServiceClient.prototype.createPlaybook =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookService/CreatePlaybook',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_CreatePlaybook,
      callback);
};


/**
 * @param {!proto.playbook.CreatePlaybookRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.playbook.PlaybookResponse>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookServicePromiseClient.prototype.createPlaybook =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookService/CreatePlaybook',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_CreatePlaybook);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.MakePrivateRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_PlaybookService_MakePrivate = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookService/MakePrivate',
  grpc.web.MethodType.UNARY,
  proto.playbook.MakePrivateRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.playbook.MakePrivateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.playbook.MakePrivateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookServiceClient.prototype.makePrivate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookService/MakePrivate',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_MakePrivate,
      callback);
};


/**
 * @param {!proto.playbook.MakePrivateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookServicePromiseClient.prototype.makePrivate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookService/MakePrivate',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_MakePrivate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.UploadFilesRequest,
 *   !proto.playbook.UploadFilesResponse>}
 */
const methodDescriptor_PlaybookService_UploadFiles = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookService/UploadFiles',
  grpc.web.MethodType.UNARY,
  proto.playbook.UploadFilesRequest,
  proto.playbook.UploadFilesResponse,
  /**
   * @param {!proto.playbook.UploadFilesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.playbook.UploadFilesResponse.deserializeBinary
);


/**
 * @param {!proto.playbook.UploadFilesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.playbook.UploadFilesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.playbook.UploadFilesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookServiceClient.prototype.uploadFiles =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookService/UploadFiles',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_UploadFiles,
      callback);
};


/**
 * @param {!proto.playbook.UploadFilesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.playbook.UploadFilesResponse>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookServicePromiseClient.prototype.uploadFiles =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookService/UploadFiles',
      request,
      metadata || {},
      methodDescriptor_PlaybookService_UploadFiles);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.playbook.PlaybookInternalServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.playbook.PlaybookInternalServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.CreatePlaybookRequest,
 *   !proto.playbook.PlaybookResponse>}
 */
const methodDescriptor_PlaybookInternalService_CreatePlaybook = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookInternalService/CreatePlaybook',
  grpc.web.MethodType.UNARY,
  proto.playbook.CreatePlaybookRequest,
  proto.playbook.PlaybookResponse,
  /**
   * @param {!proto.playbook.CreatePlaybookRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.playbook.PlaybookResponse.deserializeBinary
);


/**
 * @param {!proto.playbook.CreatePlaybookRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.playbook.PlaybookResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.playbook.PlaybookResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookInternalServiceClient.prototype.createPlaybook =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookInternalService/CreatePlaybook',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_CreatePlaybook,
      callback);
};


/**
 * @param {!proto.playbook.CreatePlaybookRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.playbook.PlaybookResponse>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookInternalServicePromiseClient.prototype.createPlaybook =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookInternalService/CreatePlaybook',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_CreatePlaybook);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.ObjectIdRequest,
 *   !proto.playbook.PlaybookResponse>}
 */
const methodDescriptor_PlaybookInternalService_GetPlaybook = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookInternalService/GetPlaybook',
  grpc.web.MethodType.UNARY,
  proto.playbook.ObjectIdRequest,
  proto.playbook.PlaybookResponse,
  /**
   * @param {!proto.playbook.ObjectIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.playbook.PlaybookResponse.deserializeBinary
);


/**
 * @param {!proto.playbook.ObjectIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.playbook.PlaybookResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.playbook.PlaybookResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookInternalServiceClient.prototype.getPlaybook =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookInternalService/GetPlaybook',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_GetPlaybook,
      callback);
};


/**
 * @param {!proto.playbook.ObjectIdRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.playbook.PlaybookResponse>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookInternalServicePromiseClient.prototype.getPlaybook =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookInternalService/GetPlaybook',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_GetPlaybook);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.UpdatePlaybookRequest,
 *   !proto.playbook.PlaybookResponse>}
 */
const methodDescriptor_PlaybookInternalService_UpdatePlaybook = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookInternalService/UpdatePlaybook',
  grpc.web.MethodType.UNARY,
  proto.playbook.UpdatePlaybookRequest,
  proto.playbook.PlaybookResponse,
  /**
   * @param {!proto.playbook.UpdatePlaybookRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.playbook.PlaybookResponse.deserializeBinary
);


/**
 * @param {!proto.playbook.UpdatePlaybookRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.playbook.PlaybookResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.playbook.PlaybookResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookInternalServiceClient.prototype.updatePlaybook =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookInternalService/UpdatePlaybook',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_UpdatePlaybook,
      callback);
};


/**
 * @param {!proto.playbook.UpdatePlaybookRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.playbook.PlaybookResponse>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookInternalServicePromiseClient.prototype.updatePlaybook =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookInternalService/UpdatePlaybook',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_UpdatePlaybook);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.ListPlaybooksInternalRequest,
 *   !proto.playbook.PlaybooksResponse>}
 */
const methodDescriptor_PlaybookInternalService_ListPlaybooks = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookInternalService/ListPlaybooks',
  grpc.web.MethodType.UNARY,
  proto.playbook.ListPlaybooksInternalRequest,
  proto.playbook.PlaybooksResponse,
  /**
   * @param {!proto.playbook.ListPlaybooksInternalRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.playbook.PlaybooksResponse.deserializeBinary
);


/**
 * @param {!proto.playbook.ListPlaybooksInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.playbook.PlaybooksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.playbook.PlaybooksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookInternalServiceClient.prototype.listPlaybooks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookInternalService/ListPlaybooks',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_ListPlaybooks,
      callback);
};


/**
 * @param {!proto.playbook.ListPlaybooksInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.playbook.PlaybooksResponse>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookInternalServicePromiseClient.prototype.listPlaybooks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookInternalService/ListPlaybooks',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_ListPlaybooks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.CreatePlaybookRunRequest,
 *   !proto.playbook.PlaybookRunResponse>}
 */
const methodDescriptor_PlaybookInternalService_CreatePlaybookRun = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookInternalService/CreatePlaybookRun',
  grpc.web.MethodType.UNARY,
  proto.playbook.CreatePlaybookRunRequest,
  proto.playbook.PlaybookRunResponse,
  /**
   * @param {!proto.playbook.CreatePlaybookRunRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.playbook.PlaybookRunResponse.deserializeBinary
);


/**
 * @param {!proto.playbook.CreatePlaybookRunRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.playbook.PlaybookRunResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.playbook.PlaybookRunResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookInternalServiceClient.prototype.createPlaybookRun =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookInternalService/CreatePlaybookRun',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_CreatePlaybookRun,
      callback);
};


/**
 * @param {!proto.playbook.CreatePlaybookRunRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.playbook.PlaybookRunResponse>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookInternalServicePromiseClient.prototype.createPlaybookRun =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookInternalService/CreatePlaybookRun',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_CreatePlaybookRun);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.ObjectIdRequest,
 *   !proto.playbook.PlaybookRunResponse>}
 */
const methodDescriptor_PlaybookInternalService_GetPlaybookRun = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookInternalService/GetPlaybookRun',
  grpc.web.MethodType.UNARY,
  proto.playbook.ObjectIdRequest,
  proto.playbook.PlaybookRunResponse,
  /**
   * @param {!proto.playbook.ObjectIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.playbook.PlaybookRunResponse.deserializeBinary
);


/**
 * @param {!proto.playbook.ObjectIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.playbook.PlaybookRunResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.playbook.PlaybookRunResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookInternalServiceClient.prototype.getPlaybookRun =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookInternalService/GetPlaybookRun',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_GetPlaybookRun,
      callback);
};


/**
 * @param {!proto.playbook.ObjectIdRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.playbook.PlaybookRunResponse>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookInternalServicePromiseClient.prototype.getPlaybookRun =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookInternalService/GetPlaybookRun',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_GetPlaybookRun);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.UpdatePlaybookRunRequest,
 *   !proto.playbook.PlaybookRunResponse>}
 */
const methodDescriptor_PlaybookInternalService_UpdatePlaybookRun = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookInternalService/UpdatePlaybookRun',
  grpc.web.MethodType.UNARY,
  proto.playbook.UpdatePlaybookRunRequest,
  proto.playbook.PlaybookRunResponse,
  /**
   * @param {!proto.playbook.UpdatePlaybookRunRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.playbook.PlaybookRunResponse.deserializeBinary
);


/**
 * @param {!proto.playbook.UpdatePlaybookRunRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.playbook.PlaybookRunResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.playbook.PlaybookRunResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookInternalServiceClient.prototype.updatePlaybookRun =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookInternalService/UpdatePlaybookRun',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_UpdatePlaybookRun,
      callback);
};


/**
 * @param {!proto.playbook.UpdatePlaybookRunRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.playbook.PlaybookRunResponse>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookInternalServicePromiseClient.prototype.updatePlaybookRun =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookInternalService/UpdatePlaybookRun',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_UpdatePlaybookRun);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.ListPlaybookRunsInternalRequest,
 *   !proto.playbook.PlaybookRunsResponse>}
 */
const methodDescriptor_PlaybookInternalService_ListPlaybookRuns = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookInternalService/ListPlaybookRuns',
  grpc.web.MethodType.UNARY,
  proto.playbook.ListPlaybookRunsInternalRequest,
  proto.playbook.PlaybookRunsResponse,
  /**
   * @param {!proto.playbook.ListPlaybookRunsInternalRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.playbook.PlaybookRunsResponse.deserializeBinary
);


/**
 * @param {!proto.playbook.ListPlaybookRunsInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.playbook.PlaybookRunsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.playbook.PlaybookRunsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookInternalServiceClient.prototype.listPlaybookRuns =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookInternalService/ListPlaybookRuns',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_ListPlaybookRuns,
      callback);
};


/**
 * @param {!proto.playbook.ListPlaybookRunsInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.playbook.PlaybookRunsResponse>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookInternalServicePromiseClient.prototype.listPlaybookRuns =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookInternalService/ListPlaybookRuns',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_ListPlaybookRuns);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.ObjectIdRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_PlaybookInternalService_DeletePlaybook = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookInternalService/DeletePlaybook',
  grpc.web.MethodType.UNARY,
  proto.playbook.ObjectIdRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.playbook.ObjectIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.playbook.ObjectIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookInternalServiceClient.prototype.deletePlaybook =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookInternalService/DeletePlaybook',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_DeletePlaybook,
      callback);
};


/**
 * @param {!proto.playbook.ObjectIdRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookInternalServicePromiseClient.prototype.deletePlaybook =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookInternalService/DeletePlaybook',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_DeletePlaybook);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.ObjectIdRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_PlaybookInternalService_DeletePlaybookRun = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookInternalService/DeletePlaybookRun',
  grpc.web.MethodType.UNARY,
  proto.playbook.ObjectIdRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.playbook.ObjectIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.playbook.ObjectIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookInternalServiceClient.prototype.deletePlaybookRun =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookInternalService/DeletePlaybookRun',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_DeletePlaybookRun,
      callback);
};


/**
 * @param {!proto.playbook.ObjectIdRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookInternalServicePromiseClient.prototype.deletePlaybookRun =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookInternalService/DeletePlaybookRun',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_DeletePlaybookRun);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.IsHeadlessChatRequest,
 *   !proto.playbook.IsHeadlessChatResponse>}
 */
const methodDescriptor_PlaybookInternalService_IsHeadlessChat = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookInternalService/IsHeadlessChat',
  grpc.web.MethodType.UNARY,
  proto.playbook.IsHeadlessChatRequest,
  proto.playbook.IsHeadlessChatResponse,
  /**
   * @param {!proto.playbook.IsHeadlessChatRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.playbook.IsHeadlessChatResponse.deserializeBinary
);


/**
 * @param {!proto.playbook.IsHeadlessChatRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.playbook.IsHeadlessChatResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.playbook.IsHeadlessChatResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookInternalServiceClient.prototype.isHeadlessChat =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookInternalService/IsHeadlessChat',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_IsHeadlessChat,
      callback);
};


/**
 * @param {!proto.playbook.IsHeadlessChatRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.playbook.IsHeadlessChatResponse>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookInternalServicePromiseClient.prototype.isHeadlessChat =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookInternalService/IsHeadlessChat',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_IsHeadlessChat);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.playbook.UpdateQuestionPlaybookPromptRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_PlaybookInternalService_UpdateQuestionPlaybookPrompt = new grpc.web.MethodDescriptor(
  '/playbook.PlaybookInternalService/UpdateQuestionPlaybookPrompt',
  grpc.web.MethodType.UNARY,
  proto.playbook.UpdateQuestionPlaybookPromptRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.playbook.UpdateQuestionPlaybookPromptRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.playbook.UpdateQuestionPlaybookPromptRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.playbook.PlaybookInternalServiceClient.prototype.updateQuestionPlaybookPrompt =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/playbook.PlaybookInternalService/UpdateQuestionPlaybookPrompt',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_UpdateQuestionPlaybookPrompt,
      callback);
};


/**
 * @param {!proto.playbook.UpdateQuestionPlaybookPromptRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.playbook.PlaybookInternalServicePromiseClient.prototype.updateQuestionPlaybookPrompt =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/playbook.PlaybookInternalService/UpdateQuestionPlaybookPrompt',
      request,
      metadata || {},
      methodDescriptor_PlaybookInternalService_UpdateQuestionPlaybookPrompt);
};


module.exports = proto.playbook;

